<template>
	<b-card>
		<template #header>
			<span style="font-size: 20px; font-weight: bold">Отчёты бортпроводников</span>
		</template>
		<b-overlay :show="loading" rounded="sm">
			<b-row>
				<b-col cols="3">
					<b-form-group breakpoint="lg" label-size="sm" label-for="fromDate" class="required" size="sm">
						<date-picker class="s" style="width:100%;" v-model="data.startDate" lang="ru" :placeholder="$t('promo-to-product.start-date')" valueType="format" format="DD-MM-YYYY"/>
					</b-form-group>
				</b-col>
				<b-col cols="3">
					<b-form-group breakpoint="lg" label-size="sm" label-for="fromDate" class="required" size="sm">
						<date-picker class="s" style="width:100%;" v-model="data.endDate" lang="ru" :placeholder="$t('promo-to-product.finish-date')" valueType="format" format="DD-MM-YYYY"/>
					</b-form-group>
				</b-col>
				<b-col>
					<multiselect v-model="employeeDtos" track-by="id" :searchable="true" :show-labels="false" :options="employees" :multiple="true" :close-on-select="true" :internal-search="false" :custom-label="sellerCustomLabel" :placeholder="`Выберите бортпроводника`" @search-change="getEmployees($event)">
						<template slot="option" slot-scope="option">
							{{ sellerCustomLabel(option.option) }}
						</template>
					</multiselect>
				</b-col>
				<b-col cols="2">
					<b-button class="fa fa-search" variant="dark" @click="getList"/>
					<download-excel v-if="list && list.length>0" size="sm" class="btn btn-success ml-2" :data="list" :fields="json_fields" worksheet="My Worksheet" name="Excel">
						<b-spinner v-if="loading" small class="mr-2"/><strong class="fa fa-download"> Excel</strong>
					</download-excel>
				</b-col>
			</b-row>
			<table class="table table-bordered table-hover">
				<thead>
				<tr>
					<th class="text-center">{{ '№' }}</th>
					<th class="text-center">{{ 'Табельный №' }}</th>
					<th class="text-center">{{ 'Ф.И.О' }}</th>
					<th class="text-center">{{ 'Сумма продаж €' }}</th>
					<th class="text-center">{{ 'Их процент €' }}</th>
					<th class="text-center">{{ 'Пенс €' }}</th>
					<th class="text-center">{{ 'ИНПС €' }}</th>
					<th class="text-center">{{ 'Под.налог €' }}</th>
					<th class="text-center">{{ 'Выручка €' }}</th>
					<th class="text-center">{{ 'Выручка Сум' }}</th>
				</tr>
				</thead>
				<tbody v-if="list.length > 0">
				<tr v-for="(item, index) in list" :key="`group-${index}`">
					<td class="text-center">{{ index+1 }}</td>
					<td class="text-center">{{ item.personnelNumber }}</td>
					<td class="text-center">{{ item.fullName }}</td>
					<td class="text-center">{{ item.esum }}</td>
					<td class="text-center">{{ item.esump }}</td>
					<td class="text-center">{{ item.esumPercentagePension }}</td>
					<td class="text-center">{{ item.esumInps }}</td>
					<td class="text-center">{{ item.esumIncomeTax }}</td>
					<td class="text-center">{{ item.esumAmount }}</td>
					<td class="text-center">{{ item.amountUzs }}</td>
				</tr>
				</tbody>
				<tbody v-else>
				<tr>
					<td class="text-center" colspan="9">{{ $t('empty') }}</td>
				</tr>
				</tbody>
			</table>
		</b-overlay>
	</b-card>
</template>

<script>
import SkyShopService from './skyshop.service';
import Multiselect from 'vue-multiselect'

export default {
	components: {Multiselect},
	data() {
		return {
			employees: [],
			employeeDtos: [],
			list: [],
			loading: false,
			data: {
				startDate: '',
				endDate: '',
				employees: []
			},
			json_fields: {
				"Табельный №": "personnelNumber",
				"Ф.И.О": "fullName",
				"Сумма продаж €": "esum",
				"Их процент €": "esump",
				"Пенс €": "esumPercentagePension",
				"ИНПС €": "esumInps",
				"Под.налог €": "esumIncomeTax",
				"Выручка €": "esumAmount",
				"Выручка Сум": "amountUzs"
			}
		}
	},
	methods: {
		getList() {
			if (this.data.startDate!==''&&this.data.endDate!=='') {
				this.loading = true
				let employees = []
				if (this.employeeDtos && this.employeeDtos.length > 0)
					this.employeeDtos.forEach(d => {
						employees.push(d.id)
					})
				this.data.employees = employees
				SkyShopService.getReportEmployeeList(this.data).then(res => {
					this.list = res.data
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				this.$vs.notify({
					title: 'Пожалуста выберите период !',
					color: 'warning',
					time: 5000,
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		getEmployees(search) {
			this.loading = true
			SkyShopService.getEmployees(search).then(res => {
				this.employees = res.data
				this.loading = false
			}).catch(er => {
				this.loading = false
				this.$vs.notify({
					title: er.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		sellerCustomLabel(seller) {
			return (seller.firstName + " " + seller.lastName + " " + seller.middleName);
		},
	},
	created() {
		this.getEmployees('');
	}
}
</script>

<style scoped>
.pointer-event:hover {
	cursor: pointer;
}
</style>
